import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector, shallowEqual } from 'react-redux';

import { selectElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';

import { useCurrentProduct } from 'components/direct-sales/quote/hooks/useCurrentProduct';
import { usePartner } from 'components/app/routes/usePartner';

export const useIsEVQuote = () => {
  const { releaseEvQuote } = useFlags();
  const { isDSJourney } = usePartner();
  const { isEV } = useCurrentProduct();
  const electricVehicle = useSelector(selectElectricVehicle, shallowEqual);

  const isEVBeforeQuote = !!electricVehicle && !!releaseEvQuote && isDSJourney;

  return {
    isEVQuote: isEV && isEVBeforeQuote,
    isEVBeforeQuote
  };
};
